<template>
    <span v-if="person" class="person-label text-truncate" v-text="`${person.firstName || person.lastName}`" />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class PersonLabel extends Vue {
        @Prop({default: () => ({})}) person
    }

    export default PersonLabel
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .text-truncate {
        max-width: 300px;

        @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
            max-width: 160px;
        }
    }
</style>
